import { Tooltip } from 'antd'
import { TooltipPropsWithTitle } from 'antd/es/tooltip'
import React, { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { Icon } from '@/components/custom-icon'

interface KolDetailDataBlockSubHeader {
  title: string
  tooltip?: TooltipPropsWithTitle
  extraContent?: ReactNode
  className?: string
}

const KolDetailDataBlockSubHeader: FunctionComponent<
  KolDetailDataBlockSubHeader
> = ({ title, tooltip, extraContent, className }) => {
  return (
    <Box className={className}>
      <LeftItems>
        <Title>{title}</Title>
        {tooltip && (
          <Tooltip {...tooltip}>
            <InfoCircle type='info-circle' />
          </Tooltip>
        )}
      </LeftItems>
      <RightItems>{extraContent}</RightItems>
    </Box>
  )
}

const Title = styled.div`
  color: ${({ theme }): string => theme.colors.gray8};
  font-size: 15px;
  font-style: normal;
  font-weight: 700;
  line-height: 140%;
`

const LeftItems = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  ${Title} {
    margin-right: 3px;
  }
`

const RightItems = styled.div`
  display: flex;
  justify-content: flex-end;
`

const Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`
const InfoCircle = styled(Icon)`
  font-size: 16px;
  color: ${({ theme }): string => theme.colors.gray7};
`

export default styled(KolDetailDataBlockSubHeader)``
